// src/services/sanitaryEventService.js
// =============================================================================
// Frontend API wrapper for Sanitary hygiene events
// =============================================================================

import apiClient from "../utils/apiClient";

function buildParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

function getErrorMessage(err) {
  return err?.response?.data?.message || err?.response?.data?.error || err?.message || "Request failed";
}

function normalizeListPayload(payload, keys = []) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];

  for (const key of keys) {
    if (Array.isArray(payload[key])) return payload[key];
  }

  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.rows)) return payload.rows;
  if (Array.isArray(payload.data)) return payload.data;

  return [];
}

function isBenignEmptyListError(err) {
  const status = err?.response?.status;
  const body = err?.response?.data;
  if (status !== 404 || !body || typeof body !== "object") return false;

  const code = String(body.code || "").toUpperCase();
  const message = String(body.message || body.error || "").toLowerCase();
  return code.includes("NOT_FOUND") || message.includes("not found") || message.includes("nie znaleziono");
}

function throwApiError(context, err) {
  const e = new Error(`${context}: ${getErrorMessage(err)}`);
  e.status = err?.response?.status;
  e.code = err?.response?.data?.code || err?.code;
  e.data = err?.response?.data;
  throw e;
}

export async function fetchSanitaryHygieneEvents(params = {}) {
  try {
    const res = await apiClient.get("/sanitary/events", { params: buildParams(params) });
    return normalizeListPayload(res.data, ["events", "hygieneEvents"]);
  } catch (err) {
    if (isBenignEmptyListError(err)) return [];
    throwApiError("fetchSanitaryHygieneEvents", err);
  }
}

const sanitaryEventService = { fetchSanitaryHygieneEvents };

export default sanitaryEventService;
